import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from '../../../internal/cx.js';
/** Indeterminate progress indicator. Server-component safe. */
export function Spinner({ size = 'md', label, className, ...rest }) {
    const a11y = label
        ? { role: 'status', 'aria-label': label }
        : { 'aria-hidden': true };
    return _jsx("span", { ...rest, ...a11y, className: cx('mn-spinner', className), "data-size": size });
}
//# sourceMappingURL=spinner.js.map